/**
 * APIS Field Codes - Used for field visibility and validation checks
 * Matches the field codes from the API response (apisFields.required and apisFields.optional)
 */
export const enum ApisFieldCode {
  // Identity & Document
  NAT = 'NAT', // Nationality
  DOT = 'DOT', // Document Type
  DOS = 'DOS', // Document Sub Type
  DON = 'DON', // Document Number
  DOE = 'DOE', // Document Expiry
  DOI = 'DOI', // Document Issue Date
  COI = 'COI', // Country of Issue
  SOI = 'SOI', // State of Issue
  POI = 'POI', // Place of Issue

  // Personal Information
  FNM = 'FNM', // First Name
  MNM = 'MNM', // Middle Name
  LNM = 'LNM', // Last Name
  GEN = 'GEN', // Gender
  DOB = 'DOB', // Date of Birth

  // Birth Information
  POB = 'POB', // Place of Birth
  COB = 'COB', // Country of Birth
  SOB = 'SOB', // State of Birth

  // Visa Information
  VIT = 'VIT', // Visa Type
  VIN = 'VIN', // Visa Number
  VDI = 'VDI', // Visa Issue Date
  VDE = 'VDE', // Visa Expiry Date
  VPI = 'VPI', // Visa Place of Issue
  VCI = 'VCI', // Visa Country of Issue
  VSI = 'VSI', // Visa State of Issue

  // Permanent Resident Information
  PRC = 'PRC', // Permanent Resident Country
  PRN = 'PRN', // Permanent Resident Number
  PRS = 'PRS', // Permanent Resident State
  PRI = 'PRI', // Permanent Resident Issue Date
  PRE = 'PRE', // Permanent Resident Expiry
  PRP = 'PRP', // Permanent Resident Place of Issue

  // Contact Information
  COR = 'COR', // Country of Residence
  HCA = 'HCA', // Home Contact Address
  HCS = 'HCS', // Home Contact State
  HCT = 'HCT', // Home Contact City
  HCZ = 'HCZ', // Home Contact Zip
  DCA = 'DCA', // Destination Contact Address
  DCS = 'DCS', // Destination Contact State
  DCT = 'DCT', // Destination Contact City
  DCZ = 'DCZ', // Destination Contact Zip

  // Additional
  RDN = 'RDN', // Redress Number
}

/**
 * Form field keys used in DynamicFormFields for APIS data.
 * These match the keys in mapApisInfoToDynamicFormValues output
 * and the DynamicFormSection field configs.
 */
export const enum ApisFormFieldKey {
  Nationality = 'nationality',
  DocumentSubType = 'documentSubType',
  DocumentNumber = 'documentNumber',
  FirstName = 'firstName',
  MiddleName = 'middleName',
  LastName = 'lastName',
  Gender = 'gender',
  DateOfBirth = 'dateOfBirth',
  CountryOfIssue = 'countryOfIssue',
  PassportExpiryDate = 'passportExpiryDate',
  VisaType = 'visaType',
  VisaNumber = 'visaNumber',
  VisaExpiryDate = 'visaExpiryDate',
  CountryOfVisa = 'countryOfVisa',
}

export const enum ApisFormSectionId {
  BasicInfo = 'basic-info',
  PassportDetails = 'passport-details',
  VisaInformation = 'visa-information',
}
